export const HOME_LICENSES_MI_STRINGS = {
  title: "Let's confirm your home is registered in\u00a0Michigan.",
  subtitle:
    'While Michigan has no state-level rental registration requirements, the city of {city} requires a few\u00a0things.',
  // Used when the home has no city on file, which is also the only case where the server falls back
  // to the coverage region to pick a program.
  'subtitle.no_city':
    'While Michigan has no state-level rental registration requirements, there are a few requirements for your\u00a0neighborhood.',

  // Variation A · Detroit — Certificate of Compliance
  'detroit.title': 'Certificate Of Compliance',
  'detroit.subtitle':
    'Detroit requires a valid Certificate Of Compliance for every rental home, and the certificate number has to appear on the\u00a0lease.',
  'detroit.number_label': 'Certificate Of Compliance Number',
  'detroit.issuance_label': 'Issuance Date (MM/DD/YYYY)',
  'detroit.expiration_label': 'Expiration Date (MM/DD/YYYY)',
  'detroit.upload_label': 'Upload Certificate',
  'detroit.info':
    'Detroit certificates renew every 2–3 years. We use the expiration date to check that the certificate is current, so that a valid certificate number is included on the\u00a0lease.',

  // Variation B · Grand Rapids — Registration & Certification
  'grand_rapids.title': 'Rental Registration &\u00a0Certification',
  'grand_rapids.subtitle':
    'Grand Rapids requires every rental home be registered and certified with the\u00a0city.',
  'grand_rapids.number_label': 'Certification Number',
  'grand_rapids.expiration_label': 'Certification Expiration (MM/DD/YYYY)',
  'grand_rapids.upload_label': 'Upload Certificate',
  'grand_rapids.info':
    "Grand Rapids caps unrelated occupants at 4. We'll include this in your lease, and handle that in the leasing process. Nothing for you to do at this\u00a0time.",

  // Variation C · Registration-only cities
  'registration.title': 'Rental Registration',
  'registration.subtitle':
    '{city} requires this rental home to be registered with the\u00a0city.',
  'registration.subtitle.no_city':
    'Your city requires this rental home to be\u00a0registered.',
  'registration.number_label': 'Registration Number',
  'registration.expiration_label': 'Registration Expiration (MM/DD/YYYY)',
  'registration.upload_label': 'Upload Registration',

  // Ann Arbor carries obligations that aren't license fields. Informational, not a blocker.
  'ann_arbor.extras':
    'Ann Arbor also requires an energy performance disclosure, the city’s rights-and-responsibilities booklet, and follows city rules on leasing timelines. We will include all of this in the lease for\u00a0you.',

  // Variation D · A city program that never applies to Belong homes
  'conditional.title': 'No Registration Required',
  'conditional.info':
    '{city} only requires rental registration for buildings with 3 or more units, so no city registration applies to this home. There is nothing for you to do at this\u00a0time.',
  'conditional.info.no_city':
    'Your city only requires rental registration for buildings with 3 or more units, so no city registration applies to this home. There is nothing for you to do at this\u00a0time.',

  // Variation E · No city program at all
  'none.title': 'No Registration Required',
  'none.info':
    '{city} has no city rental-registration program, so there is nothing for you to do at this time. Michigan’s state requirements are handled in your lease and\u00a0disclosures.',
  'none.info.no_city':
    'There is no city rental-registration program in your area, so there’s nothing to capture here. Michigan’s state requirements are handled in your lease and\u00a0disclosures.',

  // Shown when the captured expiry has already passed. A warning, not a blocker.
  expired_warning:
    "This certificate looks expired. You may continue now, and upload the renewal as soon as you have it. You'll need a current copy before your home can be listed, to ensure\u00a0compliance.",

  // Sidebar tip
  'tip.title': 'Covering Your Bases',
  'tip.description':
    "Confirming your city's registration requirements now ensures your home is compliant, and that your future Residents can sign a lease the moment they're\u00a0ready.",
};
